export default __webpack_public_path__ + "static/media/b_historia.0cdab20a.jpg";